import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.maintenance-records-report-table', () => {
  import('./internal/maintenance-records-report-table')
    .then(({ default: Component }) => Component());
});
